export const TintasEQuimicosIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9792 7.5H3.52083C2.95667 7.5 2.5 7.04333 2.5 6.47917V3.52083C2.5 2.95667 2.95667 2.5 3.52083 2.5H13.98C14.5433 2.5 15 2.95667 15 3.52083V6.48C15 7.04333 14.5433 7.5 13.9792 7.5V7.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.3333H8.33333C7.87333 18.3333 7.5 17.96 7.5 17.5V13.3333C7.5 12.8733 7.87333 12.5 8.33333 12.5H10C10.46 12.5 10.8333 12.8733 10.8333 13.3333V17.5C10.8333 17.96 10.46 18.3333 10 18.3333Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16675 12.5V10.8333C9.16675 10.3733 9.54008 10 10.0001 10H16.6667C17.1267 10 17.5001 9.62667 17.5001 9.16667V5.83333C17.5001 5.37333 17.1267 5 16.6667 5H15.0001"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
